<template>
  <div :class="`m-3 p-2 wrapper  wrapper--default`">
    <h4 class="text-center">Welcome to the PowerBI playground</h4>
    <div>
<iframe title="PiSMails" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=e108a585-5631-4aff-80cf-6fe2459867ae&appId=48b04be8-f10f-41ed-bfcf-e59d390a35da&autoAuth=true&ctid=66ef24e8-056c-4512-856c-7493718dd84e" frameborder="0" allowFullScreen="true"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  created() {},
  methods: {},
};
</script>
